import React from "react"

export const SortIcon = ({ order, ascIcon = "mdi mdi-sort-ascending", descIcon = "mdi mdi-sort-descending", noOrderIcon = "mdi mdi-sort" }) => {
  if (!order) return (<span>&nbsp;&nbsp;<i className={noOrderIcon}/></span>)
  else if (order === "asc") return (<span>&nbsp;&nbsp;<i className={ascIcon}/></span>)
  else if (order === "desc") return (<span>&nbsp;&nbsp;<i className={descIcon}/></span>)
  return null
}